import styled from 'styled-components'

const ClickableContainer = styled.div`
  cursor: pointer;
`

export default ClickableContainer
